import sha512 from 'crypto-js/sha512';
import hmacSHA512 from 'crypto-js/hmac-sha512';
import bigInt from "big-integer";
import {Constants} from "../constants/Constants";

export function SHA512Digest(message) {
    return sha512(message).toString();
}

function padHMAC512HashIfPossible(hash) {
    const max = 128
    const hashLength = hash.length
    const diff = max - hashLength
    if (diff > 0) {
        let missingPieces = [];
        for (let i = 0; i < diff; i++) {
            missingPieces.push("0")
        }
        return missingPieces.join("") + hash
    }
    return hash
}

export function HMAC512Digest(string1, string2) {
    return padHMAC512HashIfPossible(hmacSHA512(string1, string2).toString())
}

export function getNonZeroNumber(workingVal, radix) {
    let number = bigInt(workingVal).mod(radix);
    if (number.eq(bigInt(0))) {
        return number.add(bigInt(1));
    }
    return number;
}

/**
 *
 * This function generates your Lucky Roll in the Free Roller
 * **/
export function generateLuckyNumber(serverSeed, clientSeed, nonce) {
    let string1 = `${nonce}:${serverSeed}:${nonce}`
    let string2 = `${nonce}:${clientSeed}:${nonce}`
    let HMAC512Hash = HMAC512Digest(string1, string2)
    let first8Chars = HMAC512Hash?.substring(0, 8)
    let decimal = parseInt(first8Chars, 16);
    let result = decimal / 429496.7295
    // noinspection JSUnresolvedFunction
    return Math.round(result)
}

/**
 * This function generates your winning numbers in the 6/49 Game
 * **/
export function generateWinningNumbers(serverSeed, clientSeed, nonce) {
    let string1 = `${nonce}:${serverSeed}:${nonce}`;
    let string2 = `${nonce}:${clientSeed}:${nonce}`;
    let HMAC512Hash = HMAC512Digest(string1, string2);
    let first64Chars = HMAC512Hash.substring(0, 64)
    let workingVal = bigInt(first64Chars, 16, null, true)
    let radix = Constants.BASE_NUMBER
    let dissolutionCounter = 6
    let winningNumbers = []
    do {
        let number = getNonZeroNumber(workingVal, radix)
        workingVal = workingVal.divide(bigInt(radix))
        if (!winningNumbers.includes('' + number)) {
            winningNumbers.push('' + number)
            dissolutionCounter--
        }
    } while (dissolutionCounter !== 0)
    return winningNumbers
}